var App = App || {};
var currentBP = ZAGFramework.GetCurrentBP();

App.ComparisonTable = (function ($) {
    "use strict";

    var mobileBPs = ["xs", "sm", "md"],
        isMobile = false;

    function init() {
        if (mobileBPs.includes(currentBP)) {
            InitComparisonTable();
        }

        $(document).bind("enter-xs enter-sm enter-md", function () {
            InitComparisonTable();
        });

        $(document).bind("enter-lg enter-xl enter-xxl", function () {
            DestroyComparisonTable();
        });
    }

    function InitComparisonTable() {
        if (!isMobile) {
            $(".component.component-comparison-table").each(function () {
                var $component = $(this),
                    $controls = $component.find(".comparison-table-controls .form-check-input");

                $controls
                    .prop("checked", false)
                    .each(function (i) {
                        if (i < 2) {
                            $(this).prop("checked", true);
                        }
                    })
                    .on("change", function () {
                        UpdateComparisonTable($component);
                    });

                UpdateComparisonTable($component);
            });

            isMobile = true;
        }
    }

    function DestroyComparisonTable() {
        if (isMobile) {
            $(".component.component-comparison-table").each(function () {
                var $component = $(this),
                    $controls = $component.find(".comparison-table-controls .form-check-input"),
                    $comparisonTableContent = $component.find(".comparison-table-content"),
                    $columns = $component.find("th, td");

                $controls.prop("checked", false).removeAttr("disabled");
                $comparisonTableContent.show();

                $columns
                    .show()
                    .each(function () {
                        if ($(this).attr("colspan") !== undefined) {
                            $(this).attr("colspan", $controls.length);
                        }
                    });
            });

            isMobile = false;
        }
    }

    function UpdateComparisonTable($component) {
        var $controls = $component.find(".comparison-table-controls"),
            $comparisonTableContent = $component.find(".comparison-table-content"), 
            controlsChecked = [];

        $controls.find(".form-check-input").each(function () {
            var $this = $(this);

            if ($this.prop("checked")) {
                controlsChecked.push($this.attr("id"));
            }
        });

        if (!controlsChecked.length) {
            $comparisonTableContent.hide();
        }
        else {
            $comparisonTableContent.show();
        }

        $component.find("th, td").each(function () {
            var $this = $(this),
                colspan = $this.attr("colspan"),
                control = $this.data("checkbox");

            if (control) {
                if (controlsChecked.includes(control)) {
                    $this.show();
                }
                else {
                    $this.hide();
                }
            }

            if (colspan) {
                $this.attr("colspan", controlsChecked.length);
            }
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.ComparisonTable.init();
});